import progress from './progress/index.js';
import goalSetting from './goal-setting/index.js';
import PatientOverviewHN from 'dashboard/templates/views/Patient/HN/PatientOverviewHN';
import {redirectIfBehaviourModulesAreNotEnabled} from "../../../../../hooks/enabled-module-guard";

/**
 * Healthy Nutrition routes
 * @name router.Healthy-Nutrition
 */

const navigationSteps = {
  prevDiscussionStep: {
    PatientRecordHNProgress: 'PatientRecordProgress',
    PatientRecordHNGoalSetting: 'PatientRecordHNProgress',
  },
  nextDiscussionStep: {
    PatientRecordHNProgress: 'PatientRecordHNGoalSetting',
    PatientRecordHNGoalSetting: 'PatientRecordProgress',
  },
}

export default {
  path: 'healthy-nutrition',
  component: PatientOverviewHN,
  name: 'PatientRecordHN',
  props: navigationSteps,
  redirect: { name: 'PatientRecordHNProgress' },
  meta: {
    // title: 'Patient Record Healthy Nutrition',
    title: t => `${t('patient.patientRecord')} - ${t('screens.healthyNutritionSettingsScreen', 'app_mobile')}`,
    loggedInOnly: true,
  },
  children: [
    progress,
    goalSetting,
  ],
  async beforeEnter(to, from, next) {
    // If user was redirected from page because HN is not enabled, don't do anything.
    if (await redirectIfBehaviourModulesAreNotEnabled(["HEALTHYNUTRITION"], to, next)){
      return
    }

    next();
  },
};
